import script from "./UiAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiAutocomplete.vue?vue&type=script&setup=true&lang=ts"

import "./UiAutocomplete.vue?vue&type=style&index=0&id=4d50375f&scoped=true&lang=css"
script.__scopeId = "data-v-4d50375f"

export default script